module.exports = __webpack_public_path__ + "img/92087.4868fcab.svg";